import React, { lazy } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PrivateRoute } from 'components-core';

const Panel = lazy(() => import(/* webpackChunkName: "Panel" */ '../Panel'));
const Recommendation = lazy(() =>
  import(/* webpackChunkName: "Recommendation" */ '../containers/Recommendation')
);
const CreditsStatement = lazy(() =>
  import(/* webpackChunkName: "Panel" */ '../containers/CreditsStatement')
);

const PanelRoutes = () => {
  return [
    <PrivateRoute key="painel" path="/painel" component={Panel} />,
    <PrivateRoute
      key="credits-statement"
      path="/extrato-de-creditos"
      component={CreditsStatement}
    />,
    <Route
      path="/panel"
      key="panel-redirect"
      render={props => {
        const { location } = props;

        const route = location.pathname.replace('/panel', '/painel');

        return <Redirect to={route} />;
      }}
    />,
    <PrivateRoute key="referral" path="/indique-e-ganhe" component={Recommendation} />,
  ];
};

export default PanelRoutes;
